import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import {Item} from '@/components/core';
import Pager from '../_common/pager';
import productData from '../_data/product'


const PagesBody = props => {
  const {product, advantage} = props
  return (
    <div className="pages-container">
      {
        product.length > 0 && (
          <div className="pages-part1">
            <div className="wid1200">
              <div className="item-header">
                <div className="pages-title mb-default">产品功能</div>
              </div>
              <div className="item-body">
                {
                  product.map((item, ii) => {
                    return (
                      <div className="pages-item item" key={"product" + ii}>
                        <div className="pages-title-2">{item.title}</div>
                        <div>{item.desc}</div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        )
      }
      {
        advantage.length > 0 && (
          <div className="pages-part2">
            <div className="wid1200">
              <div className="item-header">
                <div className="pages-title mb-default">产品优势</div>
              </div>
              <div className="item-body">
                {
                  advantage.map((item, ii) => {
                    return (
                      <div className="mb-default" key={'advantage' + ii}>
                        <div className="pages-title-2">{item.title}</div>
                        <div>{item.desc}</div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        ) 
      }
    
    </div>
  )
}

const productType = window.location.search.split('?')[1]
console.log(productType, '====== productType', productType)
const App = (props) => {
  const data = productData.filter(item => item.type === productType)[0]
  const cfg = {
    banner: {data: [data.banner]},
    body: <PagesBody {...data} />,
  }
  return <Pager {...cfg} />
}

const root = ReactDOM.createRoot(document.getElementById('root'))
// root.render(<App />)

// document.getElementsByTagName("title")[0].innerText = '需要设置的值';